// Centralized API configuration
//export const apiURL = 'http://localhost:8000/api'; //process.env.REACT_APP_API_URL; -> Local

export const apiURL = '/api';   // New Docker
